import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <Outlet />
      </main>
      <footer className="bg-gray-800 text-gray-300 py-8 text-center">
        <p> LMS Learning System. All rights reserved.</p>
      </footer>
    </div>
  );
}
